import {Component, input} from '@angular/core';
import {FormGroup, ReactiveFormsModule} from '@angular/forms';
import {TranslatePipe} from '@ngx-translate/core';
import {DirectDebitFormModel} from './direct-debit-form.model';
import {Label} from '../../../../components/label/label';
import {TextInput} from '../../../../components/text-input/text-input';
import {ElciaDatePicker} from '../../../../components/date-picker/date-picker';

@Component({
  selector: 'elcia-direct-debit-form',
  imports: [ReactiveFormsModule, TranslatePipe, Label, TextInput, ElciaDatePicker],
  templateUrl: './direct-debit-form.html',
  styleUrl: './direct-debit-form.scss',
})
export class DirectDebitForm {
  readonly control = input.required<FormGroup<DirectDebitFormModel>>();
}
